//blog-view/src/util/get-page-title.js
import store from '@/store'
export default function getPageTitle(pageTitle) {
  /*
  const title = store.state.siteInfo.webTitleSuffix
  if (pageTitle) {
    if (title) {
      return `${pageTitle}${title}`
    }
    return pageTitle
  }
  return title
   */
  return '数据之音'
}



// WEBPACK FOOTER //
// ./src/util/get-page-title.js